interface ArchiveViewTrackingPolicyParams {
  allowAccess: boolean;
  isOwner: boolean;
  archiveAui?: string;
  settingAui?: string;
  searchable: boolean;
}

export const shouldTrackArchiveView = ({
  allowAccess,
  isOwner,
  archiveAui,
  settingAui,
  searchable,
}: ArchiveViewTrackingPolicyParams): boolean =>
  allowAccess &&
  !!archiveAui &&
  settingAui === archiveAui &&
  (isOwner || searchable);
